import { render } from "./EconomyPostPaymentsGlobalPrices.vue?vue&type=template&id=744aed39&ts=true"
import script from "./EconomyPostPaymentsGlobalPrices.vue?vue&type=script&lang=ts"
export * from "./EconomyPostPaymentsGlobalPrices.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__